<!--  -->
<template>
    <div class="business-content-main" v-loading="loading">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="search-name">汽配编码</div>
                    <el-input class="search-item" size="small" clearable v-model.trim="searchData.APCode" placeholder="请输入"></el-input>
                    <div class="search-name">汽配名称</div>
                    <el-input class="search-item" size="small" clearable v-model.trim="searchData.GoodsName" placeholder="请输入"></el-input>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" type="primary" class="search-btn" @click="setViceGoods">添加主副商品</el-button>
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    ref="multipleTable"
                    :span-method="spanMethod"
                    border=""
                    style="width: 100%"
                >
                    <el-table-column
                        width="190"
                        label="主商品编码"
                        resizable
                        prop="APCode"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <el-button class="info-button" icon="el-icon-info" type="text" @click="showAPMsgDialog(scope.row.GoodsId)"></el-button>
                            {{ scope.row.APCode }}
                        </template>  
                    </el-table-column>
                    <el-table-column
                        width="180"
                        label="主商品名称"
                        resizable
                        prop="GoodName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        width="210"
                        label="主商品车型"
                        resizable
                        prop="AutoSerise"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        width="100"
                        label="主商品库存"
                        resizable
                        prop="Inventory"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        width="180"
                        label="附属商品编码"
                        resizable
                        prop="VAPCode"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <el-button class="info-button" icon="el-icon-info" type="text" @click="showAPMsgDialog(scope.row.VGoodsId)"></el-button>
                            {{ scope.row.VAPCode }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="170"
                        label="附属商品名称"
                        resizable
                        prop="VGoodName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        width="210"
                        label="附属商品车型"
                        resizable
                        prop="VAutoSerise"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        width="120"
                        label="附属商品库存"
                        resizable
                        prop="VInventory"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        width="160"
                        label="设置时间"
                        resizable
                        prop="CreateTime"
                    ></el-table-column>
                    <el-table-column
                        width="80"
                        label="操作人"
                        resizable
                        prop="Name"
                    ></el-table-column>
                    <el-table-column fixed="right" label="操作">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button type="text" style="color: red" size="small" @click="deleteData(scope.row,true)">移出关联</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                    v-if="tableDataLength != 0"
                ></el-pagination>
            </div>
        </div>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import APMsg from '@/components/common/APMsg';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        APMsg,
        elTableColumn,
    },
    data() {
        return {
            EntpTempGoodsIdEdit: '',
            APMsgVisible: false,
            loading: false,
            stopSearch:false,
            orderId:'',
            tableData: [],
            tableDataLength: 0,
            searchData:{
                APCode:'',
                GoodsName:'',
                page:1,
                limit:15
            }
        };
    },
    created() {
        let that = this;
        document.addEventListener('keydown', that.handleKeyEvent);

    },
    mounted() {
        this.getTableData();
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            if (key === 13) {
                if(that.stopSearch) return false;
                that.handleSearch();
            }
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
        },
        // 获取列表
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsViceSetsList',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        setViceGoods(){
            this.$router.push(`/inventoryManage/goods/setViceGoods`);
        },
        deleteData(row,isCheck) {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/DeleteGoodsViceSets',
                    data: {GoodsId : row.GoodsId, ViceGoodsId : row.VGoodsId , IsCheck : isCheck},
                    hideLoading: true
                })
                .then(res => {
                    if(res.errcode === 0){
                        this.$nextTick(() => {
                            this.stopSearch = false;
                            this.$util.successMsg(res.errmsg)
                            this.getTableData();
                        },500);
                    }
                    else{
                        if(res.errcode === 200){
                            this.stopSearch = true;
                            this.$confirm('移出后，主商品【'+ row.APCode +'】不再关联任意附属商品是否移出', '确认是否删除', {
                                showClose: true,
                                type: 'warning',
                            })
                                .then(() => {
                                    this.deleteData(row,false);
                                })
                                .catch(() => {
                                    this.stopSearch = false;
                                });
                        }else{
                            this.$util.errorMsg(res.errmsg)
                        }
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        spanMethod({ row, column, rowIndex, columnIndex }){
            if (columnIndex <= 2) {
                // 获取当前单元格的值
                const currentValue = row[column.property];
                // 获取上一行相同列的值
                const preRow = this.tableData[rowIndex - 1];
                const preValue = preRow ? preRow[column.property] : null;

                // 如果当前值和上一行的值相同，则将当前单元格隐藏
                if (currentValue === preValue && this.tableData[rowIndex].GoodsId == this.tableData[rowIndex-1].GoodsId) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                } else {
                    // 否则计算当前单元格应该跨越多少行
                    let rowspan = 1;
                    for (let i = rowIndex + 1; i < this.tableData.length; i++) {
                        const nextRow = this.tableData[i];
                        const nextValue = nextRow[column.property];
                        if (nextValue === currentValue && this.tableData[i].GoodsId == this.tableData[i-1].GoodsId) {
                            rowspan++;
                        } else {
                            break;
                        }
                    }
                    return {
                        rowspan,
                        colspan: 1
                    };
                }
            }else if(columnIndex == 3){
                // 获取当前单元格的值
                const currentValue = row[column.property];
                // 获取上一行相同列的值
                const preRow = this.tableData[rowIndex - 1];
                const preValue = preRow ? preRow[column.property] : null;
                // 如果当前值和上一行的值相同，则将当前单元格隐藏
                if (currentValue === preValue && preRow && preRow.GoodsId == this.tableData[rowIndex].GoodsId) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }else{
                    const currentValue = row[column.property];
                    // 否则计算当前单元格应该跨越多少行
                    let rowspan = 1;
                    for (let i = rowIndex + 1; i < this.tableData.length; i++) {
                        const nextRow = this.tableData[i];
                        const nextValue = nextRow[column.property];

                        if (nextValue === currentValue && this.tableData[i-1].GoodsId == this.tableData[i].GoodsId) {
                            rowspan++;
                        } else {
                            break;
                        }
                    }
                    return {
                        rowspan,
                        colspan: 1
                    };
                }
            }
        }
    }
};
</script>
<style lang="less" scoped>
.info-button {
    font-size: 18px;
    color: #87A7D6;
}
</style>
